export default "__VITE_PUBLIC_ASSET__dc443f68__"